import { GET_SETTINGS } from "constants/settings";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_SETTINGS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
